<template>
    <div class="yq-datasource-select">
        <el-tag v-for="ds in cachedValue" :key="ds.id" closable @close="deleteDatasource(ds)" effect="plain">
            {{ds.name}}
        </el-tag>
        <el-button @click="showDialog" size="mini">选择数据源</el-button>
        <el-dialog
                title="选择数据源"
                :visible.sync="dialogVisible"
                width="550px" append-to-body>
            <el-form inline size="mini">
                <el-form-item label="数据源名称">
                    <el-input v-model="searchModel.nameLike" style="width: 100px"></el-input>
                </el-form-item>
                <el-form-item label="数据源类型">
                    <el-select v-model="searchModel.type" clearable multiple style="width: 120px;">
                        <el-option v-for="item in types" :key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
            <div v-if="datasources">
                <el-table
                        :data="datasources.content"
                        style="width: 100%"
                        :row-class-name="tableRowClassName">
                    <el-table-column
                            prop="name"
                            label="数据源名称">
                    </el-table-column>
                    <el-table-column
                            prop="type"
                            label="数据源类型" width="100">
                        <span slot-scope="scope">{{getTypeLabel(scope.row.type)}}</span>
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            width="100">
                        <template slot-scope="scope">
                            <el-button v-if="isSelected(scope.row)" type="text" size="small"
                                       @click="deleteDatasource(scope.row)">取消选择
                            </el-button>
                            <el-button v-else type="text" size="small"
                                       @click="addDatasource(scope.row)">选择
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        layout="prev, pager, next" background
                        :total="datasources.totalElements" :current-page="datasources.number+1"
                        @current-change="fetchDatasources"
                        style="width: fit-content;margin: 10px auto 0;">
                </el-pagination>
            </div>
            <div slot="footer" style="text-align: center;">
                <el-button type="primary" @click="dialogVisible = false">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import datasourceConfigService from '../../service/datasource-config'

    export default {
        name: "DatasourceSelect",
        props: {
            value: [Object, Array],
            multiple: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                types: datasourceConfigService.getTypes(),
                searchModel: {
                    nameLike: null,
                    type: null
                },
                searchParams: {
                    nameLike: null,
                    type: null
                },
                datasources: null,
                dialogVisible: false,
                cachedDatasources: [],
                cachedValue: []
            }
        },
        created() {
            this.init()
        },
        watch: {
            value(){
                this.init()
            }
        },
        methods: {
            async init(){
                const cachedValue = []
                if(Array.isArray(this.value)){
                    cachedValue.push(...this.value)
                }else if(this.value){
                    cachedValue.push(this.value)
                }
                if(cachedValue.length>0){
                    const ids = []
                    for(const item of cachedValue){
                        const cachedDatasource = this.cachedDatasources.find(i=>i.id===item.id)
                        if(!cachedDatasource){
                            ids.push(item.id)
                        }
                    }
                    if(ids.length>0){
                        const datasources = (await datasourceConfigService.batchGetDatasourceConfigsByIds(ids)).data
                        this.cachedDatasources.push(...datasources)
                    }
                }
                this.cachedValue = cachedValue.map(item => this.cachedDatasources.find(i=>i.id===item.id))
                    .filter(item => item)
            },
            search() {
                this.searchParams = JSON.parse(JSON.stringify(this.searchModel))
                this.fetchDatasources(1)
            },
            fetchDatasources(page) {
                datasourceConfigService.listDatasourceConfigs({
                    nameLike: this.nameLike,
                    type: this.type,
                    page: page - 1,
                    size: 10
                }).then(response => {
                    response.data.content = response.data.content.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                            type: item.type
                        }
                    })
                    this.datasources = response.data
                })
            },
            deleteDatasource(ds) {
                const newValue = [...this.cachedValue]
                newValue.splice(newValue.findIndex(item => item.id === ds.id), 1)
                this.onInput(newValue)
            },
            addDatasource(ds) {
                if (!this.multiple) {
                    this.onInput([ds])
                    return
                }
                const newValue = [...this.cachedValue]
                newValue.push(ds)
                this.onInput(newValue)
            },
            onInput(datasources) {
                datasources = datasources.map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        type: item.type
                    }
                })
                if (this.multiple) {
                    this.$emit('input', datasources)
                } else {
                    this.$emit('input', datasources.length === 0 ? null : datasources[0])
                }
            },
            isSelected(row) {
                for (const ds of this.cachedValue) {
                    if (ds.id === row.id) {
                        return true
                    }
                }
                return false
            },
            tableRowClassName({row}) {
                return this.isSelected(row) ? 'selected-row' : ''
            },
            showDialog(){
                if (!this.datasources) {
                    this.search()
                }
                this.dialogVisible = true
            },
            getTypeLabel(type){
                return this.types.find(item => item.value === type).label
            }
        }
    }
</script>
<style scoped>
    .yq-datasource-select {
        display: inline-block;
    }

    .el-table >>> .selected-row {
        background: #f0f9eb;
    }
    .el-tag{
        margin-right: 5px;
    }
</style>
